module.exports = __webpack_public_path__ + "img/library.0e0c9714.svg";